import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import { TableSearch } from './components'
import { DataTable } from './'
import { Checkbox } from 'components/forms/'
import Button from 'components/Button'
import Divider from 'components/Divider'

class MultiSelectTable extends Component {
	state = { checked: this.props.defaultChecked || [] }

	handleLoadingDataPart = (newData = []) => {
		if(this.state.isAllChecked) {
			this.setState({
				checked: newData.map(({ id, name }) => ({ id, name }))
			})
		}
	}

	handleSubmit = () => {
		this.props.closeModal()
		this.props.onSelect(this.state.checked)
	}

	handleRowClick = ({ original }) => {
		const id = original.id,
			wasChecked = this.state.checked.filter(val => val.id === id).length
		let newValues = this.state.checked
		newValues = wasChecked ? newValues.filter(val => val.id !== id) : [...newValues, { id: id, name: original.name || id }]
		const isAllChecked = newValues.length === this.props.data.length

		this.setState({
			checked: newValues,
			isAllChecked: wasChecked ? false : this.state.isAllChecked || isAllChecked
		})
	}

	headComponent = ({ onCheck, onSearch, children }) => (
		<div>
			<TableSearch onSearch={onSearch} children={children} />
			<div className='container-thead-check'>
				<div className='rt-td'>
					<Checkbox
						noForm
						checked={!!this.state.isAllChecked}
						label='Alle'
						onChange={e => {
							const checkVal = e.target.checked
							this.setState({ isAllChecked: checkVal, checked: checkVal ? this.props.data.map(({ id, name }) => ({ id: id, name: name })) : [] })
						}} />
				</div>
			</div>
		</div>
	)

	render({ columns, onSearch, defaultChecked = [], onSelect, modalConfirmBtnText, ...rest } = this.props) {
		const colsWithCheckBoxes = () => {
			let cols = [...columns]
			const insertedColInd = cols.findIndex(col => col.show !== false),
				insertedCol = cols[insertedColInd]
			cols[insertedColInd] = {
				...insertedCol,
				Cell: ({ original: { id }, value }) => (
					<Checkbox
						noForm
						readOnly
						label={value}
						checked={this.state.isAllChecked || this.state.checked.some(val => val.id === id)} />)
			}
			return cols
		}

		return(
			<Fragment>
				<DataTable
					{...rest}
					columns={colsWithCheckBoxes()}
					onRowClick={(state, rowInfo) => this.handleRowClick(rowInfo)}
					onLoadedDataPart={() => {
						this.handleLoadingDataPart(rest.data)
					}}
					noDefaultRowClick
					getTrProps={(state, rowInfo) => ({
						className: rowInfo && this.state.checked.some(item => item.id === rowInfo.original.id) ? 'tr-checked' : ''
					})}
					TheadComponent={this.headComponent}
					getTheadProps={() => ({ onSearch: searchValue => onSearch(searchValue, columns) })} />
				<Divider />
				<Button text={modalConfirmBtnText} status='primary' onClick={this.handleSubmit} />
			</Fragment>
		)
	}
}

MultiSelectTable.propTypes = {
	data: PropTypes.array.isRequired, // Data for select table
	columns: PropTypes.array.isRequired, // Columns for select table
	onSelect: PropTypes.func.isRequired,
	onSearch: PropTypes.func.isRequired,
	modalConfirmBtnText: PropTypes.string
}

MultiSelectTable.defaultProps = {
	modalConfirmBtnText: 'OK'
}

export default MultiSelectTable
